import React from 'react'
import PropTypes from 'prop-types'
import MaterialDivider from '@material-ui/core/Divider'

const Divider = ({ style = {}, offset, color, ...props }) => (
  <MaterialDivider
    style={{ margin: `${offset || 40}px 0`, background: color, ...style }}
    {...props}
  />
)

Divider.propTypes = {
  style: PropTypes.object,
  offset: PropTypes.number,
  color: PropTypes.string,
}

export default Divider



// WEBPACK FOOTER //
// ./src/components/Divider.js